exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-icon{\n    position: absolute;\n\n    top: 1;\n    margin-top: -35px;\n    border: none;\n    background: none;\n}\n", ""]);

// exports
